function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { StyledSideBySideTabsAndProcessTabsDesktopComponent } from "./side-by-side-tabs-and-process-tabs-desktop-component.scss";
import SideBySideTabsAndProcessTabs from "../side-by-side-tabs-and-process-tabs";
const SideBySideTabsAndProcessTabsDesktopComponent = (props)=>/*#__PURE__*/ _jsx(StyledSideBySideTabsAndProcessTabsDesktopComponent, {
        className: "side-by-side-tabs-and-process-tabs-desktop-component",
        children: /*#__PURE__*/ _jsx(SideBySideTabsAndProcessTabs, _object_spread({}, props))
    });
export default SideBySideTabsAndProcessTabsDesktopComponent;
